module.exports = __webpack_public_path__ + "img/logo-orange.5305e931.svg";